import {
  Flex,
  IconBeta,
  PrimaryButton,
  Typography,
  VerticalSpacing,
} from '@banhala/ui-kit';
import { bridge, useNavigator } from 'shared/src/utils';

export const Header = () => {
  const { navigator } = useNavigator();
  const handleMoveToAIOutfitTryOn = () => {
    logHandleClickAIOutfitTryOn();
    navigator.moveToWebview('CreateOutfitTryOn');
  };

  return (
    <Flex.Column alignItems={'center'}>
      <Flex.Column
        width={'100%'}
        padding={{
          horizontal: 4 + 12,
        }}
        backgroundColor={'bg_always_white'}
      >
        <Typography type="body2" color="content_tertiary">
          최근 2주동안 확인한 상품을 보여드려요
        </Typography>
        <VerticalSpacing size={12} />
        <PrimaryButton
          variant={'fill'}
          size={'small'}
          outline
          isUseOriginalIconSize={true}
          onPress={handleMoveToAIOutfitTryOn}
          rightIcon={<IconBeta />}
          iconColor={'content_positive'}
        >
          AI로 최근 본 상품 바로입기
        </PrimaryButton>
        <VerticalSpacing size={16} />
      </Flex.Column>
    </Flex.Column>
  );
};

const logHandleClickAIOutfitTryOn = () => {
  bridge.logAnalyticsEvent({
    name: 'CLICK_AI_FITTING',
    analytics: {
      SCREEN: 'RECENTLY_VIEWED_GOODS',
    },
  });
};
